export default "__VITE_ASSET__CjPhJ1ka__"